import {Col, FormGroup, Input, Label, Row} from "reactstrap";
import {I18n} from "../../../I18n/components/promoter";
import React from "react";
import "../promoter.css"

const MinutesBetweenPlaysInputRow = props => {
    const {lang, value, validator} = props;
    const fieldName = "minutesBetweenPlays";

    return (
        <Row>
            <Col xs="12" md="12" lg="12">
                <FormGroup>
                    <Label for={fieldName}>
                        {I18n[lang].minutesBetweenPlays}
                    </Label>
                    <Input
                        style={{width: "80px", display: "inline-block", margin: "0 5px 10px 5px"}}
                        type="number"
                        name={fieldName}
                        id={fieldName}
                        min="5"
                        step="5"
                        value={value || ''}
                        onChange={event => props.onChange(event.target.name, event.target.value)}
                    />
                    {validator.showErrors(fieldName)}
                </FormGroup>
            </Col>
        </Row>
    )
}

export default MinutesBetweenPlaysInputRow;


// WEBPACK FOOTER //
// ./src/components/Promoter/PromoterVideo/MinutesBetweenPlaysInputRow.js